export default "__VITE_ASSET__ByHDd36c__"